module.exports = __webpack_public_path__ + "img/marketing-speaker-icon.b31caa75.svg";